import { ComponentType, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { RoutesConfig } from "./config/Routes.config";
import useAuth from "../hooks/useAuth";
import { Loader } from "../components";

export const LazyWrapper = ({
  Component,
}: {
  Component: ComponentType<any>;
}) => {
  return (
    <Suspense fallback={<Loader />}>
      <Component />
    </Suspense>
  );
};

const DynamicOrganizationRoutes = () => {
  const {
    state: { user },
  } = useAuth();

  const allowedRoutes = RoutesConfig.filter((r) => {
    if (r.roles.length === 0) return true;
    return user && r.roles.includes(user.role);
  });

  // If user is NOT logged in AND there exists protected routes,
  // redirect to login
  const hasProtectedRoute = RoutesConfig.some((r) => r.roles.length > 0);

  if (!user && hasProtectedRoute) {
    console.log("navigare")
    return <Navigate to="/organization/login" replace />;
  }

  return (
    <Routes>
      {allowedRoutes.map(({ path, element: Element, index }) => (
        <Route
          key={`${path}_${index}`}
          {...(index ? { index: true } : { path })}
          element={<LazyWrapper Component={Element} />}
        />
      ))}

      <Route path="*" element={<div>404 - Page Not Found</div>} />
    </Routes>
  );
};

export default DynamicOrganizationRoutes;
